const PrintData = () => {
  
  return (
    <h3>Print Data</h3>
  );
} 

export default PrintData;
